export abstract class DateService {

  public static datesAreOnSameDay(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  };

  public static dateBefore(before: Date, later: Date): boolean {
    return before.getTime() < later.getTime();
  };

  public static dateAfter(later: Date, previous: Date): boolean {
    return later.getTime() > previous.getTime();
  };

}
